import { render, staticRenderFns } from "./NotificationModal.vue?vue&type=template&id=0cd6290f&scoped=true"
import script from "./NotificationModal.vue?vue&type=script&lang=js"
export * from "./NotificationModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationModal.vue?vue&type=style&index=0&id=0cd6290f&lang=css"
import style1 from "./NotificationModal.vue?vue&type=style&index=1&id=0cd6290f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd6290f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd6290f')) {
      api.createRecord('0cd6290f', component.options)
    } else {
      api.reload('0cd6290f', component.options)
    }
    module.hot.accept("./NotificationModal.vue?vue&type=template&id=0cd6290f&scoped=true", function () {
      api.rerender('0cd6290f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/ezpay/components/MessageManage/NotificationModal.vue"
export default component.exports